import { abbrNumberFilter, percentageSignFilter } from "app/filters/ngFilters";

// @ts-expect-error FIXME: Argument of type 'number' is not assignable to parameter of type 'boolean'
export const getAbsoluteFormat = (value) => abbrNumberFilter()(value, 0);
const getPercentageFormat = (value) => percentageSignFilter()(value, 2);
